// extracted by mini-css-extract-plugin
module.exports = {"OverviewDashContainer":"OverviewDash_OverviewDashContainer__3m7Wg","Section":"OverviewDash_Section__YQfq0"};